import * as React from "react";

const DateTemplate = (date: any, header?: string) => {
  return (
    <div>
      {header && 
        <span>
          <span className="ml-2 text-sm font-semibold lg:hidden lg:ml-0">
            {header}
          </span>
          <span className="mx-2 lg:hidden">-</span>
        </span>
      }
      <span>{date}</span>
    </div>
  );
};

export default DateTemplate;
